import Button from 'components/Button';
import DateTimePicker from 'components/DateTimePicker';
import Modal from 'components/Modal';
import Select from 'components/Select';
import TextField from 'components/TextField';
import Typography from 'components/Typography';
import styles from './CustomerFilterModal.module.scss';
import {SetStateAction} from 'react';
import FeatureGuard from 'components/FeatureGuard';
import useCompanyConfig from 'hooks/useCompanyConfig';

type CustomerFilterModalProps = {
  isOpen: boolean;
  onClose: () => void;
  filter: any;
  setFilter: SetStateAction<any>;
  landlordSelectOptions: any;
  propertySelectOptions: any;
  resetFilter: () => void;
  applyFilter: () => void;
};
function CustomerFilterModal({
  filter,
  isOpen,
  onClose,
  setFilter,
  landlordSelectOptions,
  propertySelectOptions,
  resetFilter,
  applyFilter,
}: CustomerFilterModalProps) {
  const {labels} = useCompanyConfig();
  return (
    <Modal
      isOpen={isOpen}
      className={styles.filterModal}
      onClose={onClose}
      onRequestClose={onClose}
    >
      <Typography variant="h2">Filter</Typography>
      <div className={styles.filterContainer}>
        <div className={styles.filterItem}>
          <DateTimePicker
            showIcon
            showTimeSelect={false}
            dateFormat="MM/dd/yy E"
            value={filter.last_offering_date.startDate}
            placeholder="Last offering date from"
            className={styles.filterInput}
            onChange={(data) => {
              setFilter((prev: any) => ({
                ...prev,
                last_offering_date: {
                  ...prev.last_offering_date,
                  startDate: data,
                },
              }));
            }}
          />

          <DateTimePicker
            showTimeSelect={false}
            dateFormat="MM/dd/yy E"
            value={filter.last_offering_date.endDate}
            placeholder="Last offering date to"
            className={styles.filterInput}
            onChange={(data) => {
              setFilter((prev: any) => ({
                ...prev,
                last_offering_date: {
                  ...prev.last_offering_date,
                  endDate: data,
                },
              }));
            }}
          />
        </div>
        <div className={styles.filterItem}>
          <TextField
            wrapperClass={styles.filterInput}
            placeholder="Total offerings from"
            value={filter.total_offerings_range.from || ''}
            onChange={(e) => {
              setFilter((prev: any) => ({
                ...prev,
                total_offerings_range: {
                  ...prev.total_offerings_range,
                  from: e.target.value,
                },
              }));
            }}
          />
          <TextField
            wrapperClass={styles.filterInput}
            placeholder="Total offerings to"
            value={filter.total_offerings_range.to || ''}
            onChange={(e) => {
              setFilter((prev: any) => ({
                ...prev,
                total_offerings_range: {
                  ...prev.total_offerings_range,
                  to: e.target.value,
                },
              }));
            }}
          />
        </div>

        <div className={styles.filterItem}>
          <DateTimePicker
            selectsRange={true}
            showTimeSelect={false}
            dateFormat="MM/dd/yy E"
            startDate={filter.dataJoined?.startDate}
            endDate={filter.dataJoined?.endDate}
            placeholder="Date joined"
            className={styles.filterInput}
            onChange={(data) => {
              setFilter((prev: any) => ({
                ...prev,
                dataJoined: {
                  startDate: data[0] || undefined,
                  endDate: data[1] || undefined,
                },
              }));
            }}
          />
          <FeatureGuard feature="hasLandlordFilterOnCustomers">
            <Select
              className={styles.filterInput}
              isSearchable={false}
              menuPosition="fixed"
              onChange={(val: any) => {
                setFilter((prev: any) => ({
                  ...prev,
                  landlord: val,
                }));
              }}
              options={landlordSelectOptions as any}
              value={filter.landlord}
              placeholder={
                <span className={styles.placeholder}>{labels.landlord}</span>
              }
              isClearable
            />
          </FeatureGuard>
        </div>
        <FeatureGuard feature="hasPropertyFilterOnCustomers">
          <div className={styles.filterItem}>
            <Select
              className={styles.filterInput}
              isSearchable={false}
              menuPosition="fixed"
              onChange={(val: any) => {
                setFilter((prev: any) => ({
                  ...prev,
                  property: val,
                }));
              }}
              options={propertySelectOptions as any}
              value={filter.property}
              placeholder={
                <span className={styles.placeholder}>{labels.property}</span>
              }
              isClearable
            />
          </div>
        </FeatureGuard>
      </div>
      <div className={styles.filterBtnContainer}>
        <Button onClick={resetFilter} color="gray">
          Reset
        </Button>
        <Button onClick={applyFilter}>Apply</Button>
      </div>
    </Modal>
  );
}
export default CustomerFilterModal;
